import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`w100`)
}
const _hoisted_2 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(``)
}
const _hoisted_3 = { class: "fs13 fw600" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr5" }, "管理用カレンダー", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = { class: "mt20" }
const _hoisted_7 = { class: "fs13" }
const _hoisted_8 = { class: "fw600" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr10" }, "通知先メールアドレス", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = {
  class: "w100 mt20 mb40",
  style: {}
}
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "fw600" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr10" }, "1日に行える最大イベント数", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = {
  key: 1,
  class: "mt10"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "fl" }
const _hoisted_24 = {
  key: 0,
  class: "circleBlueButton selected mr20",
  style: {"font-size":"17px"}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "fl" }
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.showAdminCalendarContent)
        ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_IconHelp, {
                width: 18,
                class: "fl mr10",
                tooltipText: `通常の日程確定時に登録するイベントとは別に指定カレンダーにイベントを登録できます。`,
                style: {"margin-top":"-3px"}
              })
            ]),
            _createVNode(_component_SelectTag, {
              name: "additonal_connected_calendar",
              id: "additonal_connected_calendar",
              class: "fl fs14 roundForm mt10",
              style: {"min-width":"30px","height":"50px"},
              options: _ctx.selectableCalendars(),
              defaultOption: _ctx.defaultOption(),
              onSelectValue: _ctx.selectCalendar
            }, null, 8, ["options", "defaultOption", "onSelectValue"]),
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h5", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_IconHelp, {
              width: 18,
              class: "fl mr10",
              tooltipText: `この調整カレンダーで利用している場合にオーナー以外が共通で送信されるメールアドレスを設定します。`,
              style: {"margin-top":"-3px"}
            })
          ]),
          _hoisted_10
        ]),
        _createVNode(_component_MdTextfieldTag, {
          name: "追加で通知するメールアドレス",
          style: {"height":"56px","min-width":"100%"},
          fieldStyle: "min-width:100%;",
          class: "fl fs14 mb5",
          value: _ctx.cm.astag.emails,
          onInputValue: _ctx.inputEmails,
          required: ""
        }, null, 8, ["value", "onInputValue"]),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h5", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_IconHelp, {
              width: 18,
              class: "fl mr10",
              tooltipText: `既存のイベントを含めた最大イベント数を入力します。最大値に達した日の候補は自動的に非表示になります。複数のグループが「または」でつないでいる場合は、それぞれのグループに対しての合計最大イベント数を指します。`,
              style: {"margin-top":"-3px"}
            }),
            _hoisted_16
          ]),
          _hoisted_17,
          _createVNode(_component_SelectTag, {
            name: "daily_meeting_max_num",
            id: "daily_meeting_max_num",
            class: "fl fs14 roundForm w100",
            style: {"min-width":"30px","height":"50px","max-width":"120px"},
            options: [`無制限`, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
            defaultOption: _ctx.astag.daily_meeting_max_num == -1 ? `無制限` : _ctx.astag.daily_meeting_max_num,
            onSelectValue: _ctx.selectDailyMeetingMaxNum
          }, null, 8, ["defaultOption", "onSelectValue"]),
          _hoisted_18,
          _createVNode(_component_MdTextfieldTag, {
            name: "カウントする特定のキーワードを設定",
            style: {"height":"56px","min-width":"100%"},
            fieldStyle: "min-width:100%;",
            class: "fl fs14 mb5 mt20",
            value: _ctx.astag.daily_countable_event_keyword,
            onInputValue: _ctx.inputDailyCountableEventKeyword
          }, null, 8, ["value", "onInputValue"]),
          _hoisted_19
        ]),
        _hoisted_20
      ]),
      (false && _ctx.Util.isPresent(_ctx.cm.astag.meeting_attendees_groups))
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cm.astag.meeting_attendees_groups, (mag, magindex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${magindex}${_ctx.alertTextGroupDic}${mag.name}${mag.team_name}`,
                class: "mt10 mr10 fl"
              }, [
                _createElementVNode("div", {
                  class: "borderGrey rad10 pad20 pointer hoverLightGrey",
                  onClick: ($event: any) => (_ctx.addGroupProfile(mag)),
                  style: {"width":"160px","height":"122px"}
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    (mag.name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", null, _toDisplayString(mag.name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_25,
                    (_ctx.alertTextGroupDic && _ctx.Util.isPresent(_ctx.alertTextGroupDic[mag.name]))
                      ? _withDirectives((_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.$getAssetImageUrl(`/assets/icons/bikkuri_yellow.png`),
                          width: "26",
                          height: "30",
                          class: "ml2"
                        }, null, 8, _hoisted_26)), [
                          [_directive_tooltip, _ctx.alertTextGroupDic[mag.name].join(`, `)]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    (mag.profile_image_urls)
                      ? (_openBlock(), _createBlock(_component_UserIcon, {
                          key: 0,
                          imageUrl: mag.profile_image_urls[0],
                          canEdit: false,
                          updateSelf: false,
                          width: 60
                        }, null, 8, ["imageUrl"]))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.$getAssetImageUrl(`/assets/icons/usertype_grey.png`),
                          width: "60",
                          height: "60"
                        }, null, 8, _hoisted_28))
                  ]),
                  _hoisted_29
                ], 8, _hoisted_22)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}